import React from 'react';
import pick from 'lodash/pick';
import { AnyObject } from 'react-final-form';

import { getHocDisplayName } from './hoc';

const ProxiedMetaProps = Object.freeze(['valid', 'invalid', 'dirty', 'touched', 'error', 'type', 'submitError']);

function proxyMetaProps(meta) {
  return pick(meta, ProxiedMetaProps);
}

function proxyInputProps(input) {
  return input;
}

export function createFormField(WrappedComponent) {
  const Input = ({ input, meta, ...props }: AnyObject) => (
    <WrappedComponent {...props} {...proxyMetaProps(meta)} {...proxyInputProps(input)} />
  );

  Input.displayName = getHocDisplayName('FinalFormAdapter', WrappedComponent);
  return Input;
}
